import { useEffect, useState } from "react";

import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Select,
  MenuItem,
  Typography,
  InputLabel,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import axios from "../../../../api/axios";

const BASE_URL = "./api/claim";

export default function ClaimWarranty() {
  const [mode, setMode] = useState("add");

  const [loading, setLoading] = useState(false);
  const [claimId, setClaimId] = useState(null);
  const location = useLocation();

  const claimData = location.state?.value;
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [dealershipValue, setDealershipValue] = useState(""); // State for VIN search input
  const [dealershipText, setDealershipText] = useState(""); // State for VIN search input
  const [dealershipArray, setDealershipArray] = useState([]);
  const [warrantyData, setWarrantyData] = useState("");


  const [alertOpen, setAlertOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setAlertOpen(false);
  };

  const handleSuccess = (data) => {
    setSeverity("success");
    setMessage(data.message || "Success");
    setAlertOpen(true);
    setTimeout(() => {
      navigate("/ViewClaimWarranty"); // replace with your route
    }, 1000);
  };

  const handleException = (data) => {
    setSeverity("error");
    setMessage(data.message || "Something went wrong");
    setAlertOpen(true);
  };

  const servicePostMethod = async (
    url,
    data,
    handleSuccess,
    handleException,
  ) => {
    try {
      const response = await axios.post(url, data);
      handleSuccess(response.data);
      return response.data;
    } catch (err) {
      if (err.response) {
        handleException(err.response.data);
      } else {
        handleException({ message: "No server response" });
      }
    }
  };

  const servicePutMethod = async (
    url,
    data,
    handleSuccess,
    handleException,
  ) => {
    try {
      const response = await axios.put(url, data);
      handleSuccess(response.data);
      return response.data;
    } catch (err) {
      if (err.response) {
        handleException(err.response.data);
      } else {
        handleException({ message: "No server response" });
      }
    }
  };

  const steps = [
    "Vehicle Information",
    "Customer Information",
    "Warranty Information",
    "Product Information",
    "Dealer Information",
    "Claim Information",
  ];

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  useEffect(() => {
    loadDealership();

    if (location.state?.type === "update") {
      setMode("update");

      const data = location.state.value;
      console.log("data" + JSON.stringify(data));

      setClaimId(data.id);
      setWarrantyData(data.warrantyId);
      setVinNo(data.vinNo || "");
      setMake(data.make || "");
      setModel(data.model || "");
      setYear(data.year || "");
      setOdometer(data.odometer || "");
      setSalePriceofVehicle(data.salePriceofVehicle || "");

      setComprehensiveFactoryWarrantyValid(
        data.comprehensiveFactoryWarrantyValid || "",
      );

      setWarrantyClass(data.warrantyClass || "");
      setWarrantyType(data.warrantyType || "");
      setWarrantyProtection(data.warrantyProtection || "");
      setWarrantyOption(data.warrantyOption || "");
      setHighRatioCoverage(data.highRatioCoverage || "");
      setDeductibleType(data.deductibleType || "");
      setDeductible(data.deductible || "");
      setDeductiblePrice(data.deductiblePrice || "");

      setCustomerFirstName(data.customerFirstName || "");
      setCustomerLastName(data.customerLastName || "");
      setStreetAddress(data.streetAddress || "");
      setTown(data.town || "");
      setProvince(data.province || "");
      setPostalCode(data.postalCode || "");
      setCustomerPhone(data.customerPhone || "");
      setCustomerEmail(data.customerEmail || "");
      setDriverLicence(data.driverLicence || "");

      setFinanceCompany(data.financeCompany || "");
      setVehicleDeliveryDate(data.vehicleDeliveryDate || "");
      setWarrantySoldFor(data.warrantySoldFor || "");

      setPackages(data.packages || "");
      setPackagesTypes(data.packagesTypes || "");
      setProductIndex(data.productIndex || "");
      setProductCost(data.productCost || "");
      setProductMonth(data.productMonth || "");
      setProductKm(data.productKm || "");
      setProductName(data.productName || "");
      // alert("claim date"+claimDate);
      setClaimDate(data.claimDate || "");
      setDealership(data.dealership || "");

      setRequestedClaimAmount(data.requestedClaimAmount || "");
      setPaidClaimAmount(data.paidClaimAmount || "");
    } else if (location.state?.type === "claim") {
      setMode("add");
      console.log("location.state.value", location.state.value);

      const data = location.state.value;
      setWarrantyData(data);
      setWarrantyId(data.id || "");
      setVinNo(data.vinNo || "");
      setMake(data.make || "");
      setModel(data.model || "");
      setYear(data.year || "");
      setOdometer(data.odometer || "");
      setSalePriceofVehicle(data.salePriceofVehicle || "");

      setComprehensiveFactoryWarrantyValid(
        data.comprehensiveFactoryWarrantyValid || "",
      );

      // setWarrantyClass(data.warrantyClass || "");
      // setWarrantyType(data.warrantyType || "");
      // setWarrantyProtection(data.warrantyProtection || "");
      loadWarrantyClass(data.warrantyClass);
      loadWarrantyType(data.warrantyType);
      loadWarrantyProtection(data.warrantyProtection);
      setWarrantyOption(data.warrantyOption || "");
      setHighRatioCoverage(data.highRatioCoverage || "");
      setDeductibleType(data.deductibleType || "");
      setDeductible(data.deductible || "");
      setDeductiblePrice(data.deductiblePrice || "");

      setCustomerFirstName(data.customerFirstName || "");
      setCustomerLastName(data.customerLastName || "");
      setStreetAddress(data.streetAddress || "");
      setTown(data.town || "");
      setProvince(data.province || "");
      setPostalCode(data.postalCode || "");
      setCustomerPhone(data.customerPhone || "");
      setCustomerEmail(data.customerEmail || "");
      setDriverLicence(data.driverLicence || "");

      setFinanceCompany(data.financeCompany || "");
      setVehicleDeliveryDate(data.vehicleDeliveryDate || "");
      setWarrantySoldFor(data.warrantySoldFor || "");

      setPackages(data.packages || "");
      setPackagesTypes(data.packagesTypes || "");
      setProductIndex(data.productIndex || "");
      setProductCost(data.productCost || "");
      setProductMonth(data.productMonth || "");
      setProductKm(data.productKm || "");
      setProductName(data.productName || "");

      setDealership(data.dealership || "");
      setClaimDate("");

      // Keep claim fields empty for a new claim
      setRequestedClaimAmount("");
      setPaidClaimAmount("");
    }
  }, [location]);

  const handleDealership = (newvalue) => {
    if (newvalue) {
      console.log("value", newvalue.id);
      setDealershipValue(newvalue.id);
      setDealershipText(newvalue.accountName);
    } else {
      setDealershipValue();
    }
  };

  const loadDealership = async () => {
    try {
      const URL = "./dealership";
      const response = await axios.get(URL);

      if (response.data.status === 401) {
        setDealershipArray(""); // Keep dummy data in case of unauthorized response
      } else {
        const responseData = response.data.data;
        // const dataWithIndex = response.data.data.map((item, index) => ({
        //     ...item,
        //     slNo: index + 1, // Assign sequential SL No starting from 1
        // })) || "";
        setDealershipArray(responseData);
      }
    } catch (err) {
      console.log("Error fetching data:", err);
      // Use dummy data if request fails
      setDealershipArray("");
    }
  };

  const validateClaim = () => {
    if (
      requestedClaimAmount === "" ||
      requestedClaimAmount === null ||
      requestedClaimAmount === undefined
    ) {
      setSeverity("error");
      setMessage("Requested Claim Amount is mandatory");
      setAlertOpen(true);
      return false;
    }

    if (
      paidClaimAmount === "" ||
      paidClaimAmount === null ||
      paidClaimAmount === undefined
    ) {
      setSeverity("error");
      setMessage("Paid Claim Amount is mandatory");
      setAlertOpen(true);
      return false;
    }

    return true;
  };

  //===========================
  // VEHICLE
  //===========================

  const [vinNo, setVinNo] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [odometer, setOdometer] = useState("");
  const [salePriceofVehicle, setSalePriceofVehicle] = useState("");

  //===========================
  // WARRANTY
  //===========================

  const [
    comprehensiveFactoryWarrantyValid,
    setComprehensiveFactoryWarrantyValid,
  ] = useState("");

  const [warrantyClass, setWarrantyClass] = useState("");

  const [warrantyType, setWarrantyType] = useState("");

  const [warrantyProtection, setWarrantyProtection] = useState("");

  const [warrantyOption, setWarrantyOption] = useState("");

  const [highRatioCoverage, setHighRatioCoverage] = useState("");

  const [deductibleType, setDeductibleType] = useState("");

  const [deductible, setDeductible] = useState("");

  const [deductiblePrice, setDeductiblePrice] = useState("");

  //===========================
  // CUSTOMER
  //===========================

  const [customerFirstName, setCustomerFirstName] = useState("");

  const [customerLastName, setCustomerLastName] = useState("");

  const [streetAddress, setStreetAddress] = useState("");

  const [town, setTown] = useState("");

  const [province, setProvince] = useState("");

  const [postalCode, setPostalCode] = useState("");

  const [customerPhone, setCustomerPhone] = useState("");

  const [customerEmail, setCustomerEmail] = useState("");

  const [driverLicence, setDriverLicence] = useState("");

  //===========================
  // DEAL
  //===========================

  const [financeCompany, setFinanceCompany] = useState("");

  const [vehicleDeliveryDate, setVehicleDeliveryDate] = useState("");

  const [warrantySoldFor, setWarrantySoldFor] = useState("");

  //===========================
  // PRODUCT
  //===========================

  const [packages, setPackages] = useState("");

  const [packagesTypes, setPackagesTypes] = useState("");

  const [productIndex, setProductIndex] = useState("");

  const [productCost, setProductCost] = useState("");

  const [productMonth, setProductMonth] = useState("");

  const [productKm, setProductKm] = useState("");

  const [productName, setProductName] = useState("");

  //===========================
  // DEALER
  //===========================

  const [dealership, setDealership] = useState("");

  //===========================
  // CLAIM
  //===========================

  const [requestedClaimAmount, setRequestedClaimAmount] = useState("");

  const [paidClaimAmount, setPaidClaimAmount] = useState("");

  const [claimDate, setClaimDate] = useState("");

  const [warrantyId, setWarrantyId] = useState("");

  //=====================================
  // SEARCH WARRANTY BY VIN
  //=====================================

  const searchWarranty = async () => {
    if (!vinNo) {
      handleException({ message: "Please Enter VIN Number" });
      return;
    }

    try {
      setLoading(true);

      const res = await servicePostMethod(
        "./claim/getWarrantyByVin",
        { vinNo },
        () => { },
        handleException,
      );

      if (!res) return;

      const data = res.data;

      setMake(data.make || "");

      setModel(data.model || "");

      setYear(data.year || "");

      setOdometer(data.odometer || "");

      setSalePriceofVehicle(data.salePriceofVehicle || "");

      setComprehensiveFactoryWarrantyValid(
        data.comprehensiveFactoryWarrantyValid || "",
      );

      setWarrantyClass(data.warrantyClass || "");

      setWarrantyType(data.warrantyType || "");

      setWarrantyProtection(data.warrantyProtection || "");

      setWarrantyOption(data.warrantyOption || "");

      setHighRatioCoverage(data.highRatioCoverage || "");

      setDeductibleType(data.deductibleType || "");

      setDeductible(data.deductible || "");

      setDeductiblePrice(data.deductiblePrice || "");

      setCustomerFirstName(data.customerFirstName || "");

      setCustomerLastName(data.customerLastName || "");

      setStreetAddress(data.streetAddress || "");

      setTown(data.town || "");

      setProvince(data.province || "");

      setPostalCode(data.postalCode || "");

      setCustomerPhone(data.customerPhone || "");

      setCustomerEmail(data.customerEmail || "");

      setDriverLicence(data.driverLicence || "");

      setFinanceCompany(data.financeCompany || "");

      setVehicleDeliveryDate(data.vehicleDeliveryDate || "");

      setWarrantySoldFor(data.warrantySoldFor || "");

      setPackages(data.packages || "");

      setPackagesTypes(data.packagesTypes || "");

      setProductIndex(data.productIndex || "");

      setProductCost(data.productCost || "");

      setProductMonth(data.productMonth || "");

      setProductKm(data.productKm || "");

      setProductName(data.productName || "");
      setDealership(data.dealership || "");

      setClaimDate(data.claimDate || "");

      setSeverity("success");
      setMessage("Warranty Found");
      setAlertOpen(true);

      setTimeout(() => {
        setAlertOpen(false); // Hide alert
      }, 2000); // 2
    } catch (err) {
      setSeverity("error");
      setMessage("Warranty Not Found");
      setAlertOpen(true);

      setTimeout(() => {
        setAlertOpen(false); // Hide alert
      }, 2000); // 2
    } finally {
      setLoading(false);
    }
  };

  const loadWarrantyClass = async (id) => {
    if (!id) {
      setWarrantyClass("");
      return;
    }

    try {
      const response = await axios.post("./claim/warrantyClassDetails", {
        id,
      });

      setWarrantyClass(response.data.data.warrantyClassName || "");
    } catch (err) {
      setWarrantyClass("");
    }
  };

  const loadWarrantyType = async (id) => {
    if (!id) {
      setWarrantyType("");
      return;
    }

    try {
      const response = await axios.post("./claim/warrantyTypeDetails", {
        id,
      });

      setWarrantyType(response.data.data.warrantyTypeName || "");
    } catch (err) {
      setWarrantyType("");
    }
  };
  const loadWarrantyProtection = async (id) => {
    if (!id) {
      setWarrantyProtection("");
      return;
    }

    try {
      const response = await axios.post("./claim/warrantyProtectionDetails", {
        id,
      });

      setWarrantyProtection(response.data.data.warrantyProtectionName || "");
    } catch (err) {
      setWarrantyProtection("");
    }
  };

  //=====================================
  // CREATE CLAIM
  //=====================================

  const saveClaim = async () => {
    if (!validateClaim()) return;
    try {
      setLoading(true);

      const payload = {
        vinNo,
        make,
        model,
        year,
        odometer,
        salePriceofVehicle,

        comprehensiveFactoryWarrantyValid,
        warrantyClass,
        warrantyType,
        warrantyProtection,
        warrantyOption,
        highRatioCoverage,

        deductibleType,
        deductible,
        deductiblePrice,

        customerFirstName,
        customerLastName,
        streetAddress,
        town,
        province,
        postalCode,
        customerPhone,
        customerEmail,
        driverLicence,

        financeCompany,
        vehicleDeliveryDate,
        warrantySoldFor,

        packages,
        packagesTypes,
        productIndex,
        productCost,
        productMonth,
        productKm,
        productName,

        dealership,

        requestedClaimAmount,
        paidClaimAmount,
        claimDate,
        warrantyData,
        warrantyId
      };

      await servicePostMethod(
        "./claim/create",
        payload,
        handleSuccess,
        handleException,
      );
    } catch (err) {
      alert(err.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  //=====================================
  // UPDATE CLAIM
  //=====================================

  const updateClaim = async () => {
    if (!claimId) {
      setSeverity("error");
      setMessage("Please Open Claim First");
      setAlertOpen(true);

      setTimeout(() => {
        setAlertOpen(false); // Hide alert
      }, 2000); // 2
      return;
    }

    if (!validateClaim()) return;

    try {
      setLoading(true);
      const payload = {
        vinNo,
        make,
        model,
        year,
        odometer,
        salePriceofVehicle,

        comprehensiveFactoryWarrantyValid,
        warrantyClass,
        warrantyType,
        warrantyProtection,
        warrantyOption,
        highRatioCoverage,

        deductibleType,
        deductible,
        deductiblePrice,

        customerFirstName,
        customerLastName,
        streetAddress,
        town,
        province,
        postalCode,
        customerPhone,
        customerEmail,
        driverLicence,

        financeCompany,
        vehicleDeliveryDate,
        warrantySoldFor,

        packages,
        packagesTypes,
        productIndex,
        productCost,
        productMonth,
        productKm,
        productName,

        dealership,

        requestedClaimAmount,
        paidClaimAmount,
        claimDate,
        warrantyId
      };
      await servicePutMethod(
        "./claim/" + claimId,
        payload,
        handleSuccess,
        handleException,
      );

      // alert("Updated Successfully");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3} sx={{ marginTop: "100px" }}>
      <Paper sx={{ p: 3 }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Divider sx={{ my: 3 }} />

        {/* ===========================
        STEP 1 VEHICLE
=========================== */}

        {activeStep === 0 && (
          <>
            <Typography variant="h6">Vehicle Information</Typography>

            <Grid container spacing={2} mt={1}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="VIN Number"
                  value={vinNo}
                  onChange={(e) => setVinNo(e.target.value)}
                />
              </Grid>

              {/* <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ height: 55 }}
                  onClick={searchWarranty}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Search VIN"
                  )}
                </Button>
              </Grid> */}

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Make"
                  value={make}
                  onChange={(e) => setMake(e.target.value)}
                  disabled
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Model"
                  value={model}
                  disabled
                  onChange={(e) => setModel(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Year"
                  value={year}
                  disabled
                  onChange={(e) => setYear(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Odometer"
                  value={odometer}
                  disabled
                  onChange={(e) => setOdometer(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Sale Price Of Vehicle"
                  value={salePriceofVehicle}
                  disabled
                  onChange={(e) => setSalePriceofVehicle(e.target.value)}
                />
              </Grid>
            </Grid>
          </>
        )}

        {/* ===========================
        STEP 2 CUSTOMER
=========================== */}

        {activeStep === 1 && (
          <>
            <Typography variant="h6">Customer Information</Typography>

            <Grid container spacing={2} mt={1}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="First Name"
                  disabled
                  value={customerFirstName}
                  onChange={(e) => setCustomerFirstName(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Last Name"
                  value={customerLastName}
                  disabled
                  onChange={(e) => setCustomerLastName(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Phone"
                  value={customerPhone}
                  disabled
                  onChange={(e) => setCustomerPhone(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Email"
                  value={customerEmail}
                  disabled
                  onChange={(e) => setCustomerEmail(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Driver Licence"
                  value={driverLicence}
                  disabled
                  onChange={(e) => setDriverLicence(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Street Address"
                  disabled
                  value={streetAddress}
                  onChange={(e) => setStreetAddress(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Town"
                  disabled
                  value={town}
                  onChange={(e) => setTown(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Province"
                  disabled
                  value={province}
                  onChange={(e) => setProvince(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Postal Code"
                  disabled
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                />
              </Grid>
            </Grid>
          </>
        )}

        {/* ===========================
        STEP 3 WARRANTY
=========================== */}

        {activeStep === 2 && (
          <>
            <Typography variant="h6">Warranty Information</Typography>

            <Grid container spacing={2} mt={1}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Factory Warranty Valid"
                  disabled
                  value={comprehensiveFactoryWarrantyValid}
                  onChange={(e) =>
                    setComprehensiveFactoryWarrantyValid(e.target.value)
                  }
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Warranty Class"
                  value={warrantyClass}
                  disabled
                  onChange={(e) => setWarrantyClass(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Warranty Type"
                  value={warrantyType}
                  disabled
                  onChange={(e) => setWarrantyType(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Warranty Protection"
                  value={warrantyProtection}
                  disabled
                  onChange={(e) => setWarrantyProtection(e.target.value)}
                />
              </Grid>

              {/* <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Warranty Option"
                  value={warrantyOption}
                  disabled
                  onChange={(e) => setWarrantyOption(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="High Ratio Coverage"
                  disabled
                  value={highRatioCoverage}
                  onChange={(e) => setHighRatioCoverage(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Deductible Type"
                  disabled
                  value={deductibleType}
                  onChange={(e) => setDeductibleType(e.target.value)}
                />
              </Grid> */}

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Deductible"
                  disabled
                  value={deductible}
                  onChange={(e) => setDeductible(e.target.value)}
                />
              </Grid>

              {/* <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Deductible Price"
                  disabled
                  value={deductiblePrice}
                  onChange={(e) => setDeductiblePrice(e.target.value)}
                />
              </Grid> */}
            </Grid>
          </>
        )}

        {/* ===========================
        STEP 4 PRODUCT
=========================== */}

        {activeStep === 3 && (
          <>
            <Typography variant="h6">Product Information</Typography>

            <Grid container spacing={2} mt={1}>
              <Grid
                item
                xs={4}
                sx={{
                  display: "none",
                }}
              >
                <TextField
                  fullWidth
                  label="Packages"
                  value={packages}
                  disabled
                  onChange={(e) => setPackages(e.target.value)}
                />
              </Grid>

              <Grid
                item
                xs={4}
                sx={{
                  display: "none",
                }}
              >
                <TextField
                  fullWidth
                  label="Package Types"
                  value={packagesTypes}
                  disabled
                  onChange={(e) => setPackagesTypes(e.target.value)}
                />
              </Grid>

              <Grid
                item
                xs={4}
                sx={{
                  display: "none",
                }}
              >
                <TextField
                  fullWidth
                  label="Product Index"
                  disabled
                  value={productIndex}
                  onChange={(e) => setProductIndex(e.target.value)}
                />
              </Grid>

              <Grid
                item
                xs={4}
                sx={{
                  display: "none",
                }}
              >
                <TextField
                  fullWidth
                  label="Product Month"
                  value={productMonth}
                  disabled
                  onChange={(e) => setProductMonth(e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Product Name"
                  disabled
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Product Cost"
                  disabled
                  value={productCost}
                  onChange={(e) => setProductCost(e.target.value)}
                />
              </Grid>

              <Grid
                item
                xs={4}
                sx={{
                  display: "none",
                }}
              >
                <TextField
                  fullWidth
                  label="Product KM"
                  value={productKm}
                  disabled
                  onChange={(e) => setProductKm(e.target.value)}
                />
              </Grid>
            </Grid>
          </>
        )}

        {/* ===========================
        STEP 5 DEALER
=========================== */}

        {activeStep === 4 && (
          <>
            <Typography variant="h6">Dealer Information</Typography>

            <Grid container spacing={2} mt={1}>
              {/* <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Dealership"
                  value={dealership}
                  onChange={(e) => setDealership(e.target.value)}
                />
              </Grid> */}

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Finance Company"
                  disabled
                  value={financeCompany}
                  onChange={(e) => setFinanceCompany(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Vehicle Delivery Date"
                  disabled
                  value={vehicleDeliveryDate}
                  onChange={(e) => setVehicleDeliveryDate(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Warranty Sold For"
                  disabled
                  value={warrantySoldFor}
                  onChange={(e) => setWarrantySoldFor(e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel>Dealership</InputLabel>

                  <Select
                    value={dealership}
                    disabled
                    label="Dealership"
                    onChange={(e) => setDealership(e.target.value)}
                  >
                    {dealershipArray.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.accountName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </>
        )}

        {/* ===========================
        STEP 6 CLAIM
=========================== */}

        {activeStep === 5 && (
          <>
            <Typography variant="h6">Claim Information</Typography>

            <Grid container spacing={2} mt={1}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  type="number"
                  label="Requested Claim Amount"
                  value={requestedClaimAmount}
                  onChange={(e) => setRequestedClaimAmount(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  type="number"
                  label="Paid Claim Amount"
                  value={paidClaimAmount}
                  onChange={(e) => setPaidClaimAmount(e.target.value)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  type="date"
                  label="Claim Date"
                  value={claimDate}
                  onChange={(e) => setClaimDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </>
        )}

        {/* ===========================
        STEPPER BUTTONS
=========================== */}

        <Box mt={4} display="flex" justifyContent="space-between">
          <Button
            disabled={activeStep === 0}
            variant="outlined"
            onClick={handleBack}
          >
            Back
          </Button>

          {activeStep < steps.length - 1 ? (
            <Button variant="contained" onClick={handleNext}>
              Next
            </Button>
          ) : (
            <Box display="flex" gap={2}>
              {mode === "add" && (
                <Button variant="contained" color="primary" onClick={saveClaim}>
                  Save Claim
                </Button>
              )}

              {mode === "update" && (
                <Button
                  variant="contained"
                  color="warning"
                  onClick={updateClaim}
                >
                  Update Claim
                </Button>
              )}
            </Box>
          )}
        </Box>
      </Paper>
      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
